<script setup>
import { computed } from 'vue'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { FileText, MessageSquare } from 'lucide-vue-next'

const props = defineProps({
  modelValue: {
    type: String,
    default: 'chat'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const modeOptions = [
  { value: 'chat', label: 'Chat', icon: MessageSquare },
  { value: 'report', label: 'Report', icon: FileText }
]

const selectedMode = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const isReportMode = computed(() => props.modelValue === 'report')
</script>

<template>
  <Select v-model="selectedMode" :disabled="disabled">
    <SelectTrigger
      :class="[
        'max-w-[120px]',
        isReportMode ? 'bg-blue-500/10 text-primary/75 border-blue-500 hover:bg-blue-600/10' : ''
      ]"
    >
      <SelectValue>
        <div class="flex items-center gap-1.5">
          <component
            :is="modeOptions.find(m => m.value === selectedMode)?.icon"
            class="h-4 w-4"
          />
          <span>{{ modeOptions.find(m => m.value === selectedMode)?.label }}</span>
        </div>
      </SelectValue>
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        <SelectItem
          v-for="mode in modeOptions"
          :key="mode.value"
          :value="mode.value"
        >
          <div class="flex items-center gap-2">
            <component :is="mode.icon" class="h-4 w-4" />
            <span>{{ mode.label }}</span>
          </div>
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>
